module.exports = __webpack_public_path__ + "img/5.94dcc008.jpg";